// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JWEl","textarea":"styles_textarea__3eXuB"};